/* eslint-disable import/no-extraneous-dependencies */
import { makeStyles } from '@material-ui/styles';

export default makeStyles(({
  badge: {
    fontWeight: 600,
    height: 16,
    minWidth: 16,
  },
}));
